import react.FC
import react.create
import react.router.RouterProvider
import react.useEffectOnce
import react.useState
import tech.gensert.portal.web.config.msal.msalConfig
import tech.gensert.portal.web.routes.appRouter
import tech.gensert.portal.web.showcase.reusables.LoaderComponent
import tech.gensert.portal.web.wrappers.MsalProvider
import tech.gensert.portal.web.wrappers.PublicClientApplication

private val msalInstance = PublicClientApplication(msalConfig)

val App = FC {
    val (isMsalReady, setMsalReady) = useState(false)

    useEffectOnce {
        msalInstance.initialize()
            .then {
                setMsalReady(true)
            }
            .catch {
                setMsalReady(false)
            }
    }

    when (isMsalReady) {
        true -> MsalProvider {
            instance = msalInstance
            children = ThemeModule.create {
                RouterProvider {
                    router = appRouter
                }
            }
        }
        false -> {
            LoaderComponent {}
        }
    }
}
